module.exports = __webpack_public_path__ + "static/media/usd.8d229787.svg";